import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {patch} from '@ngxs/store/operators';
import {JsonApiResponse} from '@tisa-group/cdk';
import {ClubService} from '@tisa-group/core';
import {UmpireClub} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {LoadClub} from './club.actions';

export type ClubStateModel = Record<string, JsonApiResponse<UmpireClub>>;

@State<ClubStateModel>({
  name: 'Club',
  defaults: {},
})
@Injectable()
export class ClubState {
  @Action(LoadClub)
  loadClub(
    ctx: StateContext<ClubStateModel>,
    action: LoadClub,
  ): Observable<JsonApiResponse<UmpireClub>> | JsonApiResponse<UmpireClub> {
    const stateClub = ctx.getState()[action.slug];

    if (stateClub) {
      return stateClub;
    }

    return this.clubService
      .fetch(action.slug, {
        include: ['background_photo', 'additional_asset', 'image', 'venue,teams'].join(
          ',',
        ),
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [res.data.slug as string]: res,
            }),
          ),
        ),
      );
  }

  static getClubBySlug(
    slug: string,
  ): (state: ClubStateModel) => JsonApiResponse<UmpireClub> {
    return createSelector<(state: ClubStateModel) => JsonApiResponse<UmpireClub>>(
      [ClubState],
      state => {
        return state[slug];
      },
    );
  }

  constructor(readonly clubService: ClubService) {}
}
